<template>
  <div id="app" class="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100">
    <!-- Navigation Bar -->
    <nav class="bg-white shadow-md">
      <div class="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <router-link to="/" class="flex items-center space-x-2">
          <div class="w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-lg flex items-center justify-center">
            <span class="text-white font-bold text-lg">K</span>
          </div>
          <span class="text-xl font-bold text-gray-800 hidden sm:inline">Kogeneesti</span>
        </router-link>
        <div class="space-x-4 flex">
          <router-link 
            to="/" 
            class="px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100 transition"
            active-class="bg-indigo-100 text-indigo-700"
          >
            Home
          </router-link>
          <router-link 
            to="/quizzes" 
            class="px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100 transition"
            active-class="bg-indigo-100 text-indigo-700"
          >
            Quizzes
          </router-link>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="max-w-6xl mx-auto px-4 py-8">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="bg-white border-t border-gray-200 mt-12">
      <div class="max-w-6xl mx-auto px-4 py-6 text-center text-gray-600">
        <p>&copy; 2026 Kogeneesti. Dictionaries, words, questions, quizzes, and image workflows.</p>
      </div>
    </footer>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', sans-serif;
}

a {
  text-decoration: none;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
